import MuiTypography from '@mui/material/Typography';
import { Stack, Box } from '@mui/system';
import dayjs from 'dayjs';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import _ from 'lodash';
import { Status } from '../../booking/conf/Data.conf';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import SwitchForm from '../../../components/operations/SwitchForm.component';
import operations from '../index';
import { API } from '../../operations/api';
import { API as API_SHIPPING } from '../api';
import RectangleChip from '../../../components/common/RectangleChip.component';
import { SHIPPING_TYPE_COLOR } from './Data.conf';
import { Grid, Checkbox, Chip, Typography, Tooltip } from '@mui/material';
import { StatusOperationBookingType, StatusBilling } from '../../operations/conf/Data.conf';
import TextField from '../../../components/form/components/TextField.component';
import shipping from '../index';
import SelectCustom from '../../../components/form/components/SelectCustom.component';
import DrawerSendEmail from '../../../components/common/DrawerSendEmail.component';
import { SendEmailFormConf } from './SendEmailForm.conf';
import * as yup from 'yup';
import DatePicker from '../../../components/form/components/DatePicker.component';
import TemplateDelete from '../../../pages/templates/Delete.template';
import DuplicateTemplate from '../../../pages/duplicate/Duplicate.template';

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 100,
    },
    sort: {
      by: 'operation_date',
      direction: 'desc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'checkbox_select',
      key: 'checkbox_select',
      sort_key: '',
      sortable: false,
      label: '',
      checkbox: true,
      width: 40,
      selectable: true,
    },
    {
      id: 'attributes.duplicate',
      key: 'duplicate',
      label: '',
      width: 1,
      checkbox: true,
    },
    {
      id: 'attributes.id_yacht.data',
      key: 'yacht_name',
      sort_key: 'id_yacht.yacht_name',
      sortable: true,
      label: 'Yacht Name',
      width: '200px',
    },
    {
      id: 'attributes.status_operation_booking_id',
      key: 'status_operation_booking_id',
      sort_key: 'status_operation_booking',
      sortable: true,
      label: 'Operational Status',
      width: 150,
      checkbox: true,
    },
    {
      id: 'attributes.id_shipping.data.attributes.id_shipping_type.data.attributes.shipping_type',
      key: 'id_shipping_type',
      sort_key: 'id_shipping.id_shipping_type.shipping_type',
      sortable: true,
      label: 'Shipping Type',
      width: '150px',
    },
    {
      id: 'attributes.is_parcel_for_you_id',
      key: 'is_parcel_for_you_id',
      sort_key: 'is_parcel_for_you_id',
      sortable: true,
      label: 'Parcel For You',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes.id_shipping.data.attributes.id_courier.data.attributes.name',
      key: 'id_courier',
      sort_key: 'id_shipping.id_courier.name',
      sortable: true,
      label: 'Courier',
      width: '150px',
    },
    {
      id: 'attributes.id_shipping.data.attributes.tracking_number',
      key: 'tracking_number',
      sort_key: 'id_shipping.tracking_number',
      sortable: true,
      label: 'Tracking Number',
      width: '150px',
    },
    {
      id: 'attributes.sender_id',
      key: 'sender_id',
      sort_key: 'id_shipping.sender',
      sortable: true,
      label: 'Sender',
      width: 180,
      checkbox: true,
    },
    {
      id: 'attributes.requested_date_id',
      key: 'requested_date_id',
      sort_key: 'requested_date',
      sortable: true,
      label: 'Date In',
      width: 180,
      checkbox: true,
    },
    {
      id: 'attributes.OC_fees_id',
      key: 'OC_fees_id',
      sort_key: 'OC_fees',
      sortable: true,
      label: 'Notes',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes.id_supplier.data.attributes.company_name',
      key: 'id_supplier',
      sort_key: 'id_supplier.company_name',
      sortable: true,
      label: 'Supplier',
      width: 180,
      checkbox: true,
    },
    {
      id: 'attributes.OC_BC_number_id',
      key: 'OC_BC_number_id',
      sort_key: 'OC_BC_number',
      sortable: true,
      label: 'Sales Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.OF_BF_number_id',
      key: 'OF_BF_number_id',
      sort_key: 'OF_BF_number',
      sortable: true,
      label: 'Purchase Order Number',
      width: '120px',
      checkbox: true,
    },
    {
      id: 'attributes.account_type',
      key: 'account_type',
      sort_key: 'account_type',
      sortable: true,
      label: 'CH/BOAT',
      width: '100px',
    },
    {
      id: 'attributes.status_billing_id',
      key: 'status_billing_id',
      sort_key: 'status_billing',
      sortable: true,
      label: 'Billing Status',
      width: '140px',
      checkbox: true,
    },
    {
      id: 'attributes.billing_notes_id',
      key: 'billing_notes_id',
      sort_key: 'billing_notes',
      sortable: true,
      label: 'Billing Notes',
      width: '150px',
      checkbox: true,
    },
    {
      id: 'attributes',
      key: 'delete',
      sortable: false,
      label: '',
      width: '0px',
      checkbox: true,
    },
  ],
  render: {
    formatHead: (key, value, { isChecked, indeterminate }) => {
      switch (key) {
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              indeterminate={indeterminate}
            />
          );
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick, isChecked) => {
      switch (key) {
        case 'status_operation_booking_id':
          const color = _.find(
            Status,
            (item) =>
              item.label.toUpperCase() ===
              value?.status_operation_booking?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...shipping,
                query: {
                  ...shipping.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_operation_booking: value?.status_operation_booking,
              }}
              name={'status_operation_booking'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_operation_booking'
                    name='status_operation_booking'
                    label='Operational Status'
                    options={StatusOperationBookingType}
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_operation_booking ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_operation_booking}
                    backgroundColor={color?.hex}
                    color='#fff'
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );

        case 'yacht_name': {
          const attendance =
            value?.attributes?.id_attendance?.data?.[0]?.attributes ||
            value?.attributes?.id_attendance?.data?.attributes ||
            value?.attributes?.id_yacht?.data?.attributes?.id_attendance?.data?.[0]?.attributes;
          const provenence =
            attendance?.id_provenence_list?.data?.attributes?.provenence?.data
              ?.attributes?.provenence ||
            value?.attributes?.provenence;
          const mexalCode = attendance?.mexal_code || '-';
          const mexalResearchName = attendance?.mexal_research_name || '-';
          const mexalTooltip = [mexalCode, mexalResearchName]
            .filter((item) => item && item !== '-')
            .join(' - ');

          return (
            <Tooltip title={mexalTooltip || ''}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                spacing={1}
              >
                <Stack direction={'column'} spacing={0.5}>
                  <MuiTypography
                    variant='body1'
                    sx={{ fontWeight: 'bold' }}
                    onClick={onClick}
                  >
                    {value?.attributes?.yacht_name || '-'}
                  </MuiTypography>
                  {provenence && (
                    <MuiTypography
                      variant='caption'
                      color='text.secondary'
                      onClick={onClick}
                    >
                      {provenence}
                    </MuiTypography>
                  )}
                  <Chip
                    label={`#${value?.id || '-'}`}
                    size="small"
                    sx={{ width: 'fit-content', alignSelf: 'flex-start' }}
                  />
                </Stack>
              </Stack>
            </Tooltip>
          );
        }
        case 'requested_date_id':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              name={'requested_date'}
              defaultValues={{
                requested_date: value?.requested_date,
              }}
              schema={yup.object({
                requested_date: yup
                  .string()
                  .nullable()
                  .test('is-valid-date', 'Date is required', function (value) {
                    return dayjs(value).isValid();
                  })
                  .required('Date is required'),
              })}
              form={
                <DatePicker
                  name={'requested_date'}
                  value={value?.requested_date}
                />
              }
            >
              <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <CalendarIcon color='action' />
                <MuiTypography
                  sx={{ fontWeight: 'bold', height: 1 }}
                  variant='body1'
                  onClick={onClick}
                >
                  {value?.requested_date
                    ? dayjs(value?.requested_date).format('DD-MM-YYYY')
                    : '-'}
                </MuiTypography>
              </Stack>
            </TableCellEdit>
          );
        case 'name': {
          return value ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <PersonIcon color='action' fontSize='small' />
              <MuiTypography
                sx={{ height: 1 }}
                variant='body1'
                onClick={onClick}
              >
                {`${value?.name} ${value?.surname}`}
              </MuiTypography>
            </Stack>
          ) : (
            '-'
          );
        }
        case 'is_parcel_for_you_id':
          const canBeUpdated = [
            'INCOMING CUSTOMS PARCEL',
            'INCOMING PARCEL',
          ].includes(value?.shipping_type);
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {canBeUpdated ? (
                <TableCellEdit
                  width='auto'
                  module={{
                    ...operations,
                    query: {
                      ...operations.query,
                      edit: { settings: API_SHIPPING.updateFromList },
                    },
                  }}
                  value={value}
                  name={'is_parcel_for_you'}
                  defaultValues={{
                    is_parcel_for_you: value?.is_parcel_for_you,
                  }}
                  form={<SwitchForm value={value} name={'is_parcel_for_you'} />}
                >
                  {!!value?.is_parcel_for_you ? (
                    <CheckCircleIcon color='success' sx={{ mt: '3.5px' }} />
                  ) : (
                    <CancelIcon color='error' sx={{ mt: '3.5px' }} />
                  )}
                </TableCellEdit>
              ) : (
                '-'
              )}
              {value?.is_parcel_for_you && (
                <DrawerSendEmail
                  conf={SendEmailFormConf[value?.shipping_type]}
                  id={value?.id}
                  data={{
                    mail_sended: value?.mail_sended ?? value?.attributes?.mail_sended,
                    id_yacht: value?.id_yacht,
                    email: value?.captain_email,
                    requested_date: value?.requested_date,
                    check_out_date: value?.check_out_date,
                    id_courier: value?.id_courier,
                    tracking_number: value?.tracking_number,
                    sender: value?.sender,
                    storage: value?.storage,
                    details: value?.details,
                    invoice_value: value?.invoice_value,
                    duty_paid: value?.duty_paid,
                  }}
                  tag='SHIPPING'
                  sendEmailApi={API_SHIPPING.sendEmail}
                  idKey='id_shipping'
                  tooltip='The parcel data displayed is read-only. However, it is possible to enter a different email address for sending the message (the email will not be saved). All data can be edited in the EDIT form.'
                />
              )}
            </Box>
          );
        case 'OC_BC_number_id':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OC_BC_number: value?.OC_BC_number }}
              value={value}
              name={'OC_BC_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OC_BC_number'
                    name='OC_BC_number'
                    label='Sales Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OC_BC_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );

        case 'OF_BF_number_id':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OF_BF_number: value?.OF_BF_number }}
              value={value}
              name={'OF_BF_number'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OF_BF_number'
                    name='OF_BF_number'
                    label='Purchase Order Number'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OF_BF_number || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'OC_fees_id':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ OC_fees: value?.OC_fees }}
              value={value}
              name={'OC_fees'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='OC_fees'
                    name='OC_fees'
                    label='Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.OC_fees || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'id_shipping_type':
          return value ? (
            <RectangleChip
              value={value}
              width={'auto'}
              backgroundColor={SHIPPING_TYPE_COLOR}
              color='#fff'
            />
          ) : (
            '-'
          );
        case 'checkbox_select':
          return (
            <Checkbox
              checked={isChecked || false}
              color='primary'
              disabled={onClick ? false : true}
            />
          );

        case 'billing_notes_id':
          return (
            <TableCellEdit
              module={{
                ...shipping,
                query: {
                  ...shipping.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ billing_notes: value?.billing_notes }}
              value={value}
              name={'billing_notes'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='billing_notes'
                    name='billing_notes'
                    label='Billing Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.billing_notes || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'status_billing_id':
          const colorBilling = _.find(
            StatusBilling,
            (item) =>
              item.label.toUpperCase() ===
              value?.status_billing?.toUpperCase()
          );
          return (
            <TableCellEdit
              module={{
                ...shipping,
                query: {
                  ...shipping.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              value={value}
              defaultValues={{
                status_billing: value?.status_billing,
              }}
              name={'status_billing'}
              form={
                <Grid item xs={12} sm={12}>
                  <SelectCustom
                    id='status_billing'
                    name='status_billing'
                    label='Billing Status'
                    options={StatusBilling}
                    required={true}
                  />
                </Grid>
              }
            >
              {value?.status_billing ? (
                <Box onClick={onClick}>
                  <RectangleChip
                    value={value?.status_billing}
                    backgroundColor={colorBilling?.hex}
                    color={colorBilling?.textHex}
                    width={150}
                  />
                </Box>
              ) : (
                '-'
              )}
            </TableCellEdit>
          );
        case 'supplier_correspondent':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{
                supplier_correspondent: value?.supplier_correspondent,
              }}
              value={value}
              name={'supplier_correspondent'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='supplier_correspondent'
                    name='supplier_correspondent'
                    label='Supplier'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.supplier_correspondent || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'sender_id':
          return (
            <TableCellEdit
              module={{
                ...operations,
                query: {
                  ...operations.query,
                  edit: { settings: API_SHIPPING.updateFromList },
                },
              }}
              defaultValues={{
                sender: value?.sender,
              }}
              value={value}
              name={'sender'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='sender'
                    name='sender'
                    label='Sender'
                    type='text'
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.sender || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'delete':
          return (
            <TemplateDelete module={shipping} idDelete={value?.id} isIcon>
              {value?.id_shipping?.data?.attributes?.id_shipping_type?.data
                ?.attributes?.shipping_type && (
                  <Typography component='div' mt={1}>
                    The shipping type
                    <Box fontWeight={'bold'} display='inline'>
                      {` ${value?.id_shipping?.data?.attributes?.id_shipping_type?.data?.attributes?.shipping_type} `}
                    </Box>
                    will also be deleted.
                  </Typography>
                )}
            </TemplateDelete>
          );
        case 'duplicate':
          return <DuplicateTemplate module={shipping} data={value} isIcon />;
        default:
          return (
            <MuiTypography
              variant='body1'
              onClick={onClick}
              sx={{ height: '100%' }}
            >
              {value || '-'}
            </MuiTypography>
          );
      }
    },
  },
};
